import { render, staticRenderFns } from "./discount-time-list.vue?vue&type=template&id=04e1a490&scoped=true&"
import script from "./discount-time-list.vue?vue&type=script&lang=js&"
export * from "./discount-time-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e1a490",
  null
  
)

export default component.exports